import type { FaireProductEntity } from "../../entity_types/product";

export const p_np4kqupzbd: FaireProductEntity = {
  token: "p_np4kqupzbd",
  type: "product",
  name: "Trefl Red America West 1000 Piece Puzzle",
  brandToken: "b_2gyr9m38qj",
  brandName: "Trefl USA",
  imageUrl:
    "https://cdn.faire.com/fastly/5e0db582e4a423e374d239f013a2ee9032c9d6aeb0db66b3a1db46f3a5d31151.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/94a10dc5725a49b5a04bf5a10dd8a7da1b0ac04e759b3d02cf95908345f40a54.jpeg",
    "https://cdn.faire.com/fastly/97dfda4cb13e95b54d69aad4deba8aad64d727f239cccb23a3657947f8632592.jpeg",
    "https://cdn.faire.com/fastly/400a80fe9076ad7b8747e790fa31a93c3ebc371ea3900b71eb286584eff81be7.jpeg",
    "https://cdn.faire.com/fastly/67582677a2ca8bc12e2e7765d1623e255c83e5a6de65910fd6ae03aaba081044.jpeg",
  ],
  priceDollars: 6.91,
  description:
    "Saddle up for a grand western journey. Monument Valley mesas blaze under a purple sunset while wild mustangs gallop across red earth in 1000 rugged pieces.",
  tags: [],
  msrpDollars: 13.84,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:15.884Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
